import {
  convertToKST,
  getHMFromNumber,
  getRentalTimeValue,
  PAGE_NAME,
  SearchParamsType,
} from '@orcar/common-d2c';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileOptionSearchModal } from '@/components/modal/MobileOptionSearchModal';

type MobileOptionChangeModalProps = {
  searchOptions: SearchParamsType;
  showModal: boolean;
  onClose: (option?: { onRouterBack?: boolean }) => void;
  optionIdx?: number;
};

const MobileOptionChangeModal = ({
  onClose,
  showModal,
  searchOptions,
}: MobileOptionChangeModalProps) => {
  const navigate = useNavigate();

  const [pickUpDate, setPickUpDate] = useState<Dayjs>(
    dayjs(searchOptions.pickUpAt),
  );
  const [dropOffDate, setDropOffDate] = useState<Dayjs>(
    dayjs(searchOptions.dropOffAt),
  );

  const [pickUpTimeValue, setPickUpTimeValue] = useState(
    getRentalTimeValue(searchOptions?.pickUpAt),
  );
  const [dropOffTimeValue, setDropOffTimeValue] = useState(
    getRentalTimeValue(searchOptions?.dropOffAt),
  );

  const nextBtnHandler = () => {
    const pickTimeValue = getHMFromNumber(pickUpTimeValue);
    const dropTimeValue = getHMFromNumber(dropOffTimeValue);

    const pickUpAt = convertToKST(
      pickUpDate?.set('hour', pickTimeValue.hh).set('minute', pickTimeValue.mm),
    );
    const dropOffAt = convertToKST(
      dropOffDate
        ?.set('hour', dropTimeValue.hh)
        .set('minute', dropTimeValue.mm),
    );

    navigate({
      pathname: PAGE_NAME.search,
      search: `?pickUpAt=${pickUpAt}&dropOffAt=${dropOffAt}`,
    });
  };

  return (
    <MobileOptionSearchModal
      showModal={showModal}
      onClose={onClose}
      pickUpDate={pickUpDate}
      setPickUpDate={setPickUpDate}
      dropOffDate={dropOffDate}
      setDropOffDate={setDropOffDate}
      pickUpTimeValue={pickUpTimeValue}
      setPickUpTimeValue={setPickUpTimeValue}
      dropOffTimeValue={dropOffTimeValue}
      setDropOffTimeValue={setDropOffTimeValue}
      handleNextBtn={nextBtnHandler}
    />
  );
};

export default MobileOptionChangeModal;
